<template>
  <div
    id="containcore"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div
      id="CoreTechnology1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="text" class="CoreTechnology1text">
        <div id="title">{{ $t("joinUstitle").title1 }}</div>
        <div id="text">{{ $t("joinUstitle").title2 }}</div>
      </div>
    </div>
    <div id="CoreTechnology2">
      <div
        id="title"
        class="CoreTechnology2tex wow animate__animated animate__fadeInUp"
      >
        <div id="text1">{{ $t("WorkMode").title }}</div>
        <div id="text2">P I L O T D</div>
      </div>
      <div id="grid">
        <el-row type="flex" class="row-bg1" justify="space-around">
          <el-col :span="6">
            <div
              class="grid-content bg-purple wow animate__animated animate__fadeInUp"
              style="animation-duration: 1s !important"
            >
              <div id="img">
                <img src="@/static/img/Join3icon-2-6.png" alt="" />
              </div>
              <div id="font">{{ $t("WorkMode").contentArr[0] }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="grid-content bg-purple-light wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.3s !important"
            >
              <div id="img">
                <img src="@/static/img/Join3icon-2-1.png" alt="" />
              </div>
              <div id="font">{{ $t("WorkMode").contentArr[1] }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="grid-content bg-purple wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.6s !important"
            >
              <div id="img">
                <img src="@/static/img/Join3icon-2-2.png" alt="" />
              </div>
              <div id="font">{{ $t("WorkMode").contentArr[2] }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg2" justify="space-around">
          <el-col :span="6">
            <div
              class="grid-content bg-purple wow animate__animated animate__fadeInUp"
              style="animation-duration: 1s !important"
            >
              <div id="img">
                <img src="@/static/img/Join3icon-2-3.png" alt="" />
              </div>
              <div id="font">{{ $t("WorkMode").contentArr[3] }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="grid-content bg-purple-light wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.3s !important"
            >
              <div id="img">
                <img src="@/static/img/Join3icon-2-4.png" alt="" />
              </div>
              <div id="font">{{ $t("WorkMode").contentArr[4] }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="grid-content bg-purple wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.6s !important"
            >
              <div id="img">
                <img src="@/static/img/Join3icon-2-5.png" alt="" />
              </div>
              <div id="font">{{ $t("WorkMode").contentArr[5] }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div
      id="CoreTechnology3"
      :style="{ 'background-image': 'url(' + imageUrl3 + ')' }"
      v-lazy="imageUrl3"
    >
      <div id="CoreTechnology3Content">
        <div
          id="title3"
          class="CoreTechnology3tex wow animate__animated animate__fadeInUp"
        >
          <div id="text1">{{ $t("Welfare").title }}</div>
        </div>
        <div id="grid">
          <el-row type="flex" class="row-bg1" justify="space-around">
            <el-col :span="6">
              <div
                class="grid-content bg-purple wow animate__animated animate__fadeInUp"
                style="animation-duration: 1s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-1.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[0] }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-content bg-purple-light wow animate__animated animate__fadeInUp"
                style="animation-duration: 1.3s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-2.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[1] }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-content bg-purple wow animate__animated animate__fadeInUp"
                style="animation-duration: 1.6s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-3.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[2] }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="grid-content bg-purple wow animate__animated animate__fadeInUp"
                style="animation-duration: 1.9s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-4.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[3] }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg2" justify="space-around">
            <el-col :span="6">
              <div
                class="grid-content bg-purple wow animate__animated animate__fadeInUp"
                style="animation-duration: 1s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-5.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[4] }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-content bg-purple-light wow animate__animated animate__fadeInUp"
                style="animation-duration: 1.3s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-6.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[5] }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-content bg-purple wow animate__animated animate__fadeInUp"
                style="animation-duration: 1.6s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-7.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[6] }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="grid-content bg-purple wow animate__animated animate__fadeInUp"
                style="animation-duration: 1.9s !important"
              >
                <div id="img">
                  <img src="@/static/img/Join3icon-3-8.png" alt="" />
                </div>
                <div id="font">{{ $t("Welfare").contentArr[7] }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div id="CoreTechnology4">
      <div
        id="title"
        class="CoreTechnology4tex wow animate__animated animate__fadeInUp"
      >
        <div id="text1">{{ $t("job").title }}</div>
      </div>
      <div id="tabPosition" class="wow animate__animated animate__fadeInUp">
        <el-tabs v-model="activeName">
          <!-- 社会招聘 -->
          <el-tab-pane label="社会招聘" name="first">
            <div slot="label">
              {{ $t("job").SocietyRecruitment }}
            </div>
            <div id="search">
              <el-input
                :placeholder="placeholder"
                suffix-icon="el-icon-search"
                v-model="inputSheHuiSearch"
                @input="handleInput"
              >
              </el-input>
              <div id="jobCategory">
                {{ $t("job").JobCategory }} &emsp;<span
                  class="el-icon-arrow-right"
                ></span>
              </div>
              <div class="tab">
                <button
                  v-for="(tab, index) in $t('job').Tabs"
                  :key="index"
                  @click="handleClickJob(index)"
                >
                  {{ tab }}
                </button>
              </div>
            </div>
            <!-- 社会招聘职位 -->
            <div class="tab-content">
              <div id="all">
                <el-collapse v-model="collapseValue" accordion @change="change">
                  <el-collapse-item
                    v-for="(value, index) in collaspAllData"
                    :key="index"
                    :name="index"
                  >
                    <template slot="title">
                      <div id="detail">
                        <div id="left">{{ value.left }}</div>
                        <div id="right">{{ value.right }}</div>
                      </div>
                    </template>
                    <div id="jobContent">
                      <div id="jobContent">
                        <div id="workTitle">{{ value.workTitle }}</div>
                        <div
                          v-for="(item, index) in value.workTitleArr"
                          :key="index"
                        >
                          <div id="font1">{{ item.content }}</div>
                        </div>
                      </div>
                    </div>
                    <div id="postRequirement">
                      <div id="postRequirement">
                        <div id="workTitle">{{ value.postRequirement }}</div>
                        <div
                          v-for="(item, index) in value.postRequirementArr"
                          :key="index"
                        >
                          <div id="font6">{{ item.content }}</div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-tab-pane>
          <!-- 校园招聘 -->
          <el-tab-pane label="校园招聘" name="second">
            <div slot="label">
              {{ $t("job").CampusRecruitment }}
            </div>
            <div id="search">
              <el-input
                :placeholder="placeholder"
                suffix-icon="el-icon-search"
                v-model="inputSchoolSearch"
                @input="handleSchoolInput"
              >
              </el-input>
              <div id="jobCategory">
                {{ $t("job").JobCategory }} &emsp;<span
                  class="el-icon-arrow-right"
                ></span>
              </div>
              <div class="tab">
                <button
                  v-for="(tab, index) in $t('job').Tabs"
                  :key="index"
                  @click="activeSchoolTab(index, 'school')"
                >
                  {{ tab }}
                </button>
              </div>
            </div>
            <!-- 校园招聘职位 -->
            <div class="tab-content">
              <div id="all">
                <el-collapse v-model="collapseValue" accordion @change="change">
                  <el-collapse-item
                    v-for="(value, index) in schoolAllData"
                    :key="index"
                    :name="index"
                  >
                    <template slot="title">
                      <div id="detail">
                        <div id="left">{{ value.left }}</div>
                        <div id="right">{{ value.right }}</div>
                      </div>
                    </template>
                    <div id="jobContent">
                      <div id="jobContent">
                        <div id="font1">{{ value.salary }}</div>
                        <div id="workTitle">{{ value.workTitle }}</div>
                        <div
                          v-for="(item, index) in value.workTitleArr"
                          :key="index"
                        >
                          <div id="font1">{{ item.content }}</div>
                        </div>
                      </div>
                    </div>
                    <div id="postRequirement">
                      <div id="postRequirement">
                        <div id="workTitle">{{ value.postRequirement }}</div>
                        <div
                          v-for="(item, index) in value.postRequirementArr"
                          :key="index"
                        >
                          <div id="font6">{{ item.content }}</div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div id="email">
          <div id="emailTop">{{ $t("job").contact }}</div>
          <div id="emailbuttom">{{ $t("job").cooperation }}</div>
        </div>
      </div>
    </div>
    <div id="footerss">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>
<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  components: {
    FooterComponents,
  },

  data() {
    return {
      //社会招聘下横向的tab切换
      inputSheHuiSearch: "",
      inputSchoolSearch: "",
      activeName: "first",
      imageUrl1: require("@/static/img/JoinUsBanner.png"),
      imageUrl3: require("@/static/img/joinbgfuli.png"),
      Destination: 0,
      flag: true,
      Flagmove: false,
      CoreTechnology1Text: document.getElementsByClassName(
        "CoreTechnology1text"
      ),
      CoreTechnology2Text:
        document.getElementsByClassName("CoreTechnology2tex"),
      CoreTechnology3Text: document.getElementsByClassName(
        "CoreTechnology3text"
      ),
      CoreTechnology4Text: document.getElementsByClassName(
        "CoreTechnology4text"
      ),
      CoreTechnology4Video: document.getElementsByClassName(
        "CoreTechnology4video"
      ),
      // ---------------
      tab: "",
      placeholder: "请输入搜索名称",
      collapseValue: "",
      collaspAllDataCopy: "",
      schoolAllDataCopy: "",
      collaspAllData: this.$t("job").collaspAllData,
      schoolAllData: this.$t("job").schoolAllData,
    };
  },

  updated() {
    if (this.tab && this.tab == "tab") {
      this.tab = "";
    } else {
      this.placeholder = this.$t("job").keyword;
      this.collaspAllData = this.$t("job").collaspAllData;
      this.schoolAllData = this.$t("job").schoolAllData;
      this.collaspAllDataCopy = this.$t("job").collaspAllData;
      this.schoolAllDataCopy = this.$t("job").schoolAllData;
    }
  },

  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },

  mounted() {
    //特效
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
    this.collaspAllDataCopy = this.$t("job").collaspAllData;
    this.schoolAllDataCopy = this.$t("job").schoolAllData;
  },

  methods: {
    // 手风琴展开时的函数
    change() {
      this.tab = "tab";
    },
    handleInput(value) {
      this.tab = "tab";
      this.collaspAllData = this.$t("job").collaspAllData.filter((item) =>
        item.left.includes(value)
      );
    },
    handleSchoolInput(value) {
      this.tab = "tab";
      this.schoolAllData = this.$t("job").schoolAllData.filter((item) =>
        item.left.includes(value)
      );
    },
    handleClickJob(index, school) {
      this.tab = "tab";
      this.inputSheHuiSearch = "";
      let lang = localStorage.getItem("lang");
      let tab = "全部";
      if (lang == "zh-CN") {
        switch (index) {
          case 0:
            tab = "全部";
            break;
          case 1:
            tab = "技术研发";
            break;
          case 2:
            tab = "产品/项目";
            break;
          case 3:
            tab = "战略/市场";
            break;
          case 4:
            tab = "职能支持";
            break;
          default:
            break;
        }
      }
      if (lang == "en-US") {
        switch (index) {
          case 0:
            tab = "全部";
            break;
          case 1:
            tab = "R&D";
            break;
          case 2:
            tab = "Product/Project";
            break;
          case 3:
            tab = "Strategy/Marketing";
            break;
          case 4:
            tab = "Functions";
            break;
          default:
            break;
        }
      }
      if (school == "school") {
        // 校园招聘中分类
        if (tab == "全部") {
          this.schoolAllData = this.schoolAllDataCopy.filter((item) => {
            return item.Name == "Product";
          });
        } else {
          this.schoolAllData = this.schoolAllDataCopy.filter((item) => {
            return item.label == tab;
          });
        }
      } else {
        // 社会招聘中分类
        if (tab == "全部") {
          this.collaspAllData = this.collaspAllDataCopy.filter((item) => {
            return item.Name == "all";
          });
        } else {
          this.collaspAllData = this.collaspAllDataCopy.filter((item) => {
            return item.label == tab;
          });
        }
      }

      this.collapseValue = ""; // 切换面板时将 collapseValue 设置为空字符串，保持面板关闭状态
    },
    activeSchoolTab(index, school) {
      this.handleClickJob(index, school);
    },
  },

  watch: {
    "$route.query.refresh": function () {
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
//下到上
:global(.animate__toTop1) {
  animation-name: zoomInToTop1;
}

@keyframes zoomInToTop1 {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

:global(.animate__toTop1) {
  animation-duration: 1s !important;
}

@mixin fontStyle($fontwight, $fontsize, $lineheight, $color) {
  color: $color;
  font-style: normal;
  text-align: center;
  font-size: $fontsize;
  font-weight: $fontwight;
  line-height: $lineheight;
}

@mixin display {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
}

@mixin whar($width, $height, $atio) {
  width: $width;
  height: $height;
  aspect-ratio: $atio;
  box-sizing: border-box;
}

@mixin tabsStyle($bgcolor, $top, $left, $color) {
  padding-top: 0;
  background: $bgcolor;
  box-sizing: border-box;
  padding: $top $left;
  color: $color;
}

#containcore {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
}

#CoreTechnology1 {
  @include whar(100%, auto, 2880/960);
  background-size: cover;
  padding: 12.9375rem 12.8125rem 0 12.8125rem;

  #text {
    @include fontStyle(600, 2.5rem, 7.75rem, rgba(255, 255, 255, 0.85));
    display: flex;
    flex-direction: column;
    text-align: left;

    #title {
      text-align: left;
      width: fit-content;
      line-height: 3.875rem;
    }

    #text {
      top: 3.5rem;
      width: fit-content;
      line-height: 3.875rem;
    }
  }
}

#CoreTechnology2 {
  @include display;
  width: 100%;
  aspect-ratio: 1440/535;
  box-sizing: border-box;
  padding: 4.875rem 0 4.625rem 0;

  #title {
    height: 5rem;

    #text1 {
      @include fontStyle(600, 2.25rem, 3.125rem, rgba(255, 255, 255, 0.85));
    }

    #text2 {
      margin-top: 0.5rem;
      letter-spacing: 0.5rem;
      text-transform: uppercase;
      @include fontStyle(300, 1rem, 1.1875rem, rgba(255, 255, 255, 0.2));
    }
  }

  #grid {
    width: 50.375rem;
    margin-top: 3rem;

    .el-row {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-col {
      border-radius: 4px;
    }

    .grid-content {
      @include display;
      min-height: 2.25rem;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 0.5rem 0.1rem 0rem;

      #img {
        width: 4rem;
        height: 4rem;

        img {
          width: 4rem;
          object-fit: cover;
        }
      }

      #font::first-letter {
        color: #d71f28;
      }

      #font {
        // span {
        //   color: #D71F28;
        // }

        margin-top: 1rem;
        width: fit-content;
        white-space: nowrap;
        @include fontStyle(400, 1rem, 2.25rem, rgba(255, 255, 255, 0.85));
      }
    }

    .row-bg1 {
      padding: 0.625rem 0;
    }

    .row-bg2 {
      padding: 0.625rem 0;
      margin-top: 3.375rem;
    }
  }
}

#CoreTechnology3 {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-direction: column;
  @include whar(100%, auto, 2880/988);
  background-size: cover;
  /* padding: 4.875rem 0 4.625rem 0; */

  #CoreTechnology3Content {
    #title3 {
      height: 3.125rem;

      #text1 {
        @include fontStyle(600, 2.25rem, 3.125rem, rgba(255, 255, 255, 0.85));
      }
    }

    #grid {
      /* background-color: red; */
      /* height: 16.5rem; */
      width: 50.375rem;
      margin-top: 3rem;

      .row-bg2 {
        margin-top: 3.375rem;
      }

      .el-col {
        border-radius: 0.25rem;

        .grid-content {
          width: 8.125rem;
          height: 6.75rem;
          @include display;
          border-radius: 0.25rem;
          min-height: 2.25rem;

          #img {
            width: 4rem;
            height: 4rem;

            img {
              width: 4rem;
              object-fit: cover;
            }
          }

          #font {
            width: fit-content;
            @include fontStyle(400, 1rem, 2.25rem, rgba(255, 255, 255, 0.85));
            white-space: nowrap;
          }
        }
      }
    }
  }
}

#CoreTechnology4 {
  width: 100%;
  height: auto;
  @include display;
  box-sizing: border-box;
  padding: 4.875rem 19.8125rem;

  #title {
    height: 3.125rem;

    #text1 {
      @include fontStyle(600, 2.25rem, 3.125rem, rgba(255, 255, 255, 0.85));
    }
  }

  #tabPosition {
    margin-top: 2rem;
    width: 50.375rem;

    //两个招聘tab切换
    ::v-deep .el-tabs__header {
      margin: 0 0 1.5rem;
    }

    //清除下划线得
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0rem;
    }

    ::v-deep .el-tabs__nav {
      // width: 9.5rem;
      height: 2.25rem;
      background: #070a16;
      /* background: #3051d4; */
      line-height: 2.125rem;
      border-radius: 0.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ::v-deep .el-tabs__item {
      /* margin: auto; */
      // width: 4.5rem !important;
      height: 1.75rem !important;
      line-height: 1.75rem !important;
      font-size: 0.875rem !important;
    }

    ::v-deep .tab-first {
      margin: 0.25rem 0 0.25rem 0.25rem;
    }

    ::v-deep .tab-second {
      margin: 0.25rem 0.25rem 0.25rem 0;
    }

    /* 鼠标经过时候 */
    ::v-deep .el-tabs__item:hover {
      cursor: pointer;
      color: rgba(255, 255, 255, 1);
    }

    /* 清除每一个框得下面横线 */
    ::v-deep .el-tabs__active-bar {
      height: 0rem;
    }

    /* 每一个tab原生样式 */
    ::v-deep .el-tabs__item {
      text-align: center;
      border-radius: 0.25rem;
      @include tabsStyle(#070a16, 0rem, 0.5rem, rgba(255, 255, 255, 0.45));
    }

    //选中的样式
    ::v-deep .el-tabs__item.is-active {
      text-align: center;
      border-radius: 0.25rem;
      @include tabsStyle(#d71f28, 0rem, 0.5rem, rgba(255, 255, 255, 1));
    }

    //搜索栏
    #search {
      height: 2rem;
      display: flex;
      margin-bottom: 1.5rem;
      box-sizing: border-box;

      /* 修改placehodler文字颜色 */
      ::v-deep .el-input__inner::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.25);
      }

      ::v-deep .el-input__inner::-moz-placeholder {
        color: rgba(255, 255, 255, 0.25);
      }

      ::v-deep .el-input__inner:-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.25);
      }

      ::v-deep .el-input__inner::placeholder {
        color: rgba(255, 255, 255, 0.25);
      }

      //输入框得大小
      ::v-deep .el-color-picker__icon,
      .el-input,
      .el-textarea {
        width: 33%;
        height: 2rem;
      }

      //输入框图标的高
      ::v-deep .el-input__icon {
        font-size: 0.875rem;
        line-height: 2rem;
        margin-right: 0.75rem;
      }

      ::v-deep .el-input__inner {
        height: 2rem;
        background: #0e1330;
        border: 0.0625rem solid #282d45;
        font-size: 0.875rem;
        padding-left: 0.75rem;
      }

      #jobCategory {
        width: 7rem;
        height: 2rem;
        margin-left: 2rem;
        white-space: nowrap;
        @include fontStyle(500, 0.875rem, 2rem, rgba(255, 255, 255, 0.85));

        span {
          color: rgba(255, 255, 255, 0.25);
        }
      }

      .tab {
        width: 24rem;
        height: 100%;
        display: flex;
        margin-left: 2.2294rem;
        justify-content: space-between;
      }

      .tab button {
        border: none;
        cursor: pointer;
        background-color: transparent;
        @include fontStyle(400, 0.875rem, auto, rgba(255, 255, 255, 0.85));
        min-width: 3rem;
      }

      .tab button:focus,
      .tab button:hover {
        color: red;
      }
    }

    //tab的主要内容
    .tab-content {
      width: 100%;
      position: relative;

      //每一个折叠框里面的内容
      #detail {
        width: 45rem;
        display: flex;
        font-size: 1rem;
        justify-content: space-between;

        #left {
          font-size: 1rem;
          font-weight: 500;
          font-style: normal;
          line-height: 2.25rem;
          color: rgba(255, 255, 255, 0.85);
        }

        #right {
          font-weight: 400;
          font-size: 0.75rem;
          text-align: right;
          font-style: normal;
          line-height: 2.25rem;
          color: rgba(255, 255, 255, 0.45);
        }
      }

      /* title的左边据 */
      ::v-deep .el-collapse-item__header {
        //每一个折叠版的高度
        height: 3.5rem;
        background: #0e1330;
        border-radius: 0.25rem;
        border: 1px solid #282d45;
        padding-left: 2rem !important;
        color: rgba(255, 255, 255, 0.85);

        .el-collapse-item__arrow {
          margin: 0px 1.6044rem 0 auto;
        }
      }

      //折叠面板上下线消失
      ::v-deep .el-collapse {
        margin-top: 1rem;
        border-top: 0px solid #ebeef5;
        border-bottom: 0px solid #ebeef5;
      }

      ::v-deep .el-collapse-item {
        margin-bottom: 1rem;
      }

      #jobContent {
        color: rgba(255, 255, 255, 0.85);
        text-align: left;

        #workTitle {
          margin: 1rem 0 0 2rem;
          @include fontStyle(500, 1rem, 2.25rem, rgba(255, 255, 255, 0.85));
          text-align: left;
        }

        #font1,
        #font2,
        #font3,
        #font4,
        #font5 {
          margin-left: 2rem;
          @include fontStyle(400, 0.875rem, 2.25rem, rgba(255, 255, 255, 0.65));
          text-align: left;
        }
      }

      #postRequirement {
        margin-top: 0.75rem;
        background: #0e1330;
        color: rgba(255, 255, 255, 0.85);

        #workTitle {
          @include fontStyle(500, 1rem, 2.25rem, rgba(255, 255, 255, 0.85));
          margin-left: 2rem;
          text-align: left;
        }

        #font6,
        #font7,
        #font8,
        #font9,
        #font10,
        #font11 {
          @include fontStyle(400, 0.875rem, 2.25rem, rgba(255, 255, 255, 0.65));
          margin-left: 2rem;
          text-align: left;
        }
      }

      //折叠面板里的颜色
      ::v-deep .el-collapse-item__wrap {
        background: #0e1330;
        border: 1px solid #282d45;
        border-top: 0px solid #282d45;
      }
    }

    .tab-content > div {
      display: none;
      text-transform: capitalize;
      @include fontStyle(400, 0.875rem, 1.3755rem, rgba(255, 255, 255, 0.65));
    }

    .tab-content > div:first-child {
      display: block;
    }

    #email {
      display: flex;
      height: 2.75rem;
      margin-top: 1rem;
      text-align: left;
      width: fit-content;
      flex-direction: column;
      // text-transform: capitalize;
      @include fontStyle(400, 0.75rem, 2.75rem, rgba(255, 255, 255, 0.65));

      #emailTop {
        height: 1.375rem;
        line-height: 1.375rem;
        // text-transform: initial;
      }

      #emailbuttom {
        height: 1.375rem;
        line-height: 1.375rem;
        text-align: left;
      }
    }
  }
}

#footerss {
  height: 18rem;
}

.en {
  #CoreTechnology1text,
  #emailTop,
  #emailbuttom {
    line-height: 1.5 !important;
  }
}
</style>
